import { useEffect, useState } from "react";
import { FileText, Lock, UploadCloud, X } from "lucide-react";
import { StepHeader } from "@/components/apply/Field";

const SLOTS = [
  ["id_front", "ID — Front", "Government-issued photo ID"],
  ["id_back", "ID — Back", "Back side of the same ID"],
  ["selfie", "Selfie holding your ID", "Face and ID clearly visible"],
];

const Preview = ({ file }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!file || file.type === "application/pdf") {
      setUrl("");
      return undefined;
    }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  if (url) return <img src={url} alt="" className="h-full w-full object-cover" />;
  return <div className="grid place-items-center h-full text-muted-foreground"><FileText className="h-10 w-10" /><span className="text-xs px-2 truncate max-w-full">{file.name}</span></div>;
};

const Slot = ({ k, title, sub, file, onPick }) => (
  <div className="space-y-2" data-testid={`apply-upload-${k}`}>
    <p className="font-bold text-sm">{title}</p>
    <label className="relative block aspect-[4/3] rounded-2xl border-2 border-dashed border-border hover:border-primary bg-card overflow-hidden cursor-pointer transition-colors">
      {file ? <Preview file={file} /> : (
        <div className="h-full grid place-items-center text-center p-4">
          <div><UploadCloud className="h-8 w-8 mx-auto text-primary" /><p className="mt-2 text-sm font-semibold">Tap to upload</p><p className="text-xs text-muted-foreground">{sub}</p></div>
        </div>
      )}
      <input type="file" accept="image/jpeg,image/png,application/pdf" className="hidden" data-testid={`apply-upload-input-${k}`} onChange={(e) => onPick(e.target.files?.[0] || null)} />
    </label>
    {file && (
      <button type="button" onClick={() => onPick(null)} className="text-xs font-semibold text-muted-foreground hover:text-destructive inline-flex items-center gap-1" data-testid={`apply-upload-remove-${k}`}>
        <X className="h-3 w-3" /> Remove
      </button>
    )}
  </div>
);

export const StepId = ({ form, setForm }) => {
  const pick = (k) => (file) => setForm((f) => ({ ...f, files: { ...f.files, [k]: file } }));
  return (
    <div data-testid="step-id">
      <StepHeader title="Verify your identity" text="Accepted formats: JPG, PNG or PDF (max 10MB each)." />
      <div className="grid gap-5 sm:grid-cols-3">
        {SLOTS.map(([k, t, s]) => <Slot key={k} k={k} title={t} sub={s} file={form.files[k]} onPick={pick(k)} />)}
      </div>
      <div className="mt-6 flex items-start gap-3 rounded-2xl bg-primary/10 border border-primary/30 p-4 text-sm">
        <Lock className="h-5 w-5 text-primary shrink-0" />
        <p>Your documents are encrypted and stored securely. Only our admin team can view them, and they can be deleted after verification.</p>
      </div>
    </div>
  );
};
